import OverviewInfoContent from './OverviewInfoContent';

export default OverviewInfoContent;
